import { api } from "./api";

let configPromise = null;
export const paymentConfig = () => (configPromise ||= api.get("/payments/config").then(r => r.data).catch(() => { configPromise = null; return {enabled: false}; }));

export const loadSnap = (clientKey, snapUrl) => new Promise((resolve, reject) => {
  if (window.snap) return resolve(window.snap);
  const existing = document.querySelector(`script[src="${snapUrl}"]`);
  const script = existing || document.createElement("script");
  const done = () => window.snap ? resolve(window.snap) : reject(new Error("Snap tidak tersedia"));
  script.addEventListener("load", done, {once: true});
  script.addEventListener("error", () => reject(new Error("Midtrans Snap tidak dapat dimuat")), {once: true});
  if (!existing) { script.src = snapUrl; script.setAttribute("data-client-key", clientKey); document.head.appendChild(script); }
});

export const payWithSnap = (snap, token) => new Promise(resolve => snap.pay(token, {
  onSuccess: () => resolve("success"), onPending: () => resolve("pending"), onError: () => resolve("error"), onClose: () => resolve("closed"),
}));
